import React from 'react';

import { FormTextField, FormTextFieldProps, TextFieldProps } from '../form-text-field';

type Props = Omit<FormTextFieldProps, 'validationOptions' | 'type'> & TextFieldProps;

export const FormFirstNameField: React.FC<Props> = ({
  autoComplete = 'given-name',
  label = 'First Name',
  required,
  ...props
}) => {
  return (
    <FormTextField
      {...props}
      type="text"
      label={label}
      autoComplete={autoComplete}
      validationOptions={{ required, maxLength: 50 }}
      data-testid="formFirstNameInput"
    />
  );
};
